type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const TrashIcon = (props:IconProps) => {
	const {
		width = 24,
		height = 24,
		color = 'var(--func-red-default)'
	} = props;
	return (
		<svg role={'img'} viewBox={'0 0 18 18'} height={height} width={width} xmlns={'http://www.w3.org/2000/svg'} fill='none' {...props}>
			<path d='M5.25 16.15C4.8375 16.15 4.48438 16.0031 4.19062 15.7094C3.89687 15.4156 3.75 15.0625 3.75 14.65V4.90002H3V3.40002H6.75V2.65002H11.25V3.40002H15V4.90002H14.25V14.65C14.25 15.0625 14.1031 15.4156 13.8094 15.7094C13.5156 16.0031 13.1625 16.15 12.75 16.15H5.25ZM12.75 4.90002H5.25V14.65H12.75V4.90002ZM6.75 13.15H8.25V6.40002H6.75V13.15ZM9.75 13.15H11.25V6.40002H9.75V13.15Z' fill={color}/>
		</svg>
	);
};